import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseMaintenanceSolicitationsProps<T> = {
  filters?: {
    search?: string
    status?: string
    clientBranchId?: string
    equipmentId?: string
    kind?: string
    page?: number
  }
  mapper?: (data: any) => T
}

export const useMaintenanceSolicitations = <T,>({
  filters: { search = '', status, clientBranchId, equipmentId, kind, page } = {},
  mapper = Mapper.default<T>(),
}: UseMaintenanceSolicitationsProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['maintenanceSolicitations', search, status, clientBranchId, equipmentId, kind, page],
    queryFn: () => {
      return privateAxios.get(`/maintenance/solicitations`, {
        params: {
          search,
          'q[status_eq]': status,
          'q[branch_id_eq]': clientBranchId,
          'q[equipment_id_eq]': equipmentId,
          'q[kind_eq]': kind,
          page,
        },
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
